import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dBigInt from "../Data.BigInt/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as TcgCalculator$dMath from "../TcgCalculator.Math/index.js";
import * as TcgCalculator$dTypes from "../TcgCalculator.Types/index.js";
const monoidSet = /* #__PURE__ */ Data$dSet.monoidSet(Data$dUUID.ordUUID);
const foldMap = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidSet))();
const foldMap1 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidSet))();
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const sumBy = dictSemiring => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupAdditive1 = {append: v => v1 => dictSemiring.add(v)(v1)};
  return {mempty: dictSemiring.zero, Semigroup0: () => semigroupAdditive1};
})());
const sumBy1 = /* #__PURE__ */ sumBy(Data$dSemiring.semiringInt);
const and = /* #__PURE__ */ Data$dFoldable.and(Data$dMap$dInternal.foldableMap)(Data$dHeytingAlgebra.heytingAlgebraBoolean);
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v === "LT") { return x; }
  if (v === "EQ") { return x; }
  if (v === "GT") { return y; }
  $runtime.fail();
};
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v === "LT") { return y; }
  if (v === "EQ") { return x; }
  if (v === "GT") { return x; }
  $runtime.fail();
};
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dUUID.ordUUID)(Data$dFoldable.foldableArray);
const mapAccumL = /* #__PURE__ */ Data$dTraversable.mapAccumL(Data$dTraversable.traversableArray);
const lookup = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const sumBy3 = /* #__PURE__ */ sumBy(Data$dBigInt.semiringBigInt);
const normalizeDeck = v => conditions => {
  const v1 = Data$dArray.partitionImpl(
    (() => {
      const $0 = foldMap(foldMap1(v1 => v1.cards))(conditions);
      return a => member(a.id)($0);
    })(),
    v.cards
  );
  return {cards: Data$dArray.sortWith(Data$dUUID.ordUUID)(v2 => v2.id)(v1.yes), others: v.others + sumBy1(v2 => v2.count)(v1.no) | 0, hand: v.hand};
};
const normalizeConditionPatterns = /* #__PURE__ */ Data$dFoldable.foldrArray(condition => patterns => {
  if (
    Data$dArray.anyImpl(
      general => {
        const covered = Data$dMap$dInternal.unsafeIntersectionWith(Data$dUUID.ordUUID.compare, s => g => g.min <= s.min && s.max <= g.max, condition, general);
        return (() => {
          if (covered.tag === "Leaf") { return 0; }
          if (covered.tag === "Node") { return covered._2; }
          $runtime.fail();
        })() === (() => {
          if (general.tag === "Leaf") { return 0; }
          if (general.tag === "Node") { return general._2; }
          $runtime.fail();
        })() && and(covered);
      },
      patterns
    )
  ) {
    return patterns;
  }
  return [
    condition,
    ...Data$dArray.filterImpl(
      x => {
        const covered = Data$dMap$dInternal.unsafeIntersectionWith(Data$dUUID.ordUUID.compare, s => g => g.min <= s.min && s.max <= g.max, x, condition);
        return !(
          (() => {
            if (covered.tag === "Leaf") { return 0; }
            if (covered.tag === "Node") { return covered._2; }
            $runtime.fail();
          })() === (() => {
            if (condition.tag === "Leaf") { return 0; }
            if (condition.tag === "Node") { return condition._2; }
            $runtime.fail();
          })() && and(covered)
        );
      },
      patterns
    )
  ];
})([]);
const mkDrawPattern = v => v1 => {
  if (v < 0) { return []; }
  if (v === 0) { return [[]]; }
  const capacity = sumBy1(v2 => v2.count)(v1);
  if (capacity < v) { return []; }
  return Data$dFoldable.foldrArray(v2 => v3 => v4 => v5 => {
    if (v4 === 0) { return [[]]; }
    if (v2.count === 0) { return v3(v4)(v5); }
    const capacity$p = v5 - v2.count | 0;
    const draws = Control$dBind.arrayBind(Data$dArray.rangeImpl(min(v4)(v2.count), max(1)(v4 - capacity$p | 0)))(draw => Data$dFunctor.arrayMap(v6 => [{card: v2, draw}, ...v6])(v3(v4 - draw | 0)(capacity$p)));
    if (capacity$p < v4) { return draws; }
    return [...draws, ...v3(v4)(capacity$p)];
  })(v2 => v3 => [[]])(v1)(v)(capacity);
};
const mkConditionPattern = cards => v => {
  const cards$p = TcgCalculator$dTypes.filterCards(v.cards)(cards);
  return Data$dFunctor.arrayMap((() => {
    const $0 = Data$dFunctor.arrayMap(x => Data$dTuple.$Tuple(x.card.id, x));
    const $1 = Data$dArray.filter(v1 => !(v1.min === 0 && v1.max === v1.card.count));
    return x => fromFoldable($0($1(x)));
  })())((() => {
    if (v.mode === "AtLeast") {
      return Data$dFunctor.arrayMap(v1 => Data$dFunctor.arrayMap(p => ({card: p.card, min: p.draw, max: p.card.count}))(v1))(mkDrawPattern(v.count)(cards$p));
    }
    if (v.mode === "JustDraw") {
      return Data$dFunctor.arrayMap(v1 => mapAccumL(i => card => {
        if (i >= 0 && i < v1.length && v1[i].card.id === card.id) {
          return {
            accum: i + 1 | 0,
            value: (() => {
              const $0 = v1[i].draw;
              return {card, min: $0, max: $0};
            })()
          };
        }
        return {accum: i, value: {card, min: 0, max: 0}};
      })(0)(cards$p).value)(mkDrawPattern(v.count)(cards$p));
    }
    if (v.mode === "Remains") {
      return Data$dFunctor.arrayMap(v1 => mapAccumL(i => card => {
        if (i >= 0 && i < v1.length && v1[i].card.id === card.id) { return {accum: i + 1 | 0, value: {card, min: 0, max: v1[i].draw}}; }
        return {accum: i, value: {card, min: 0, max: 0}};
      })(0)(cards$p).value)(mkDrawPattern(sumBy1(v1 => v1.count)(cards$p) - v.count | 0)(cards$p));
    }
    if (v.mode === "JustRemains") {
      return Data$dFunctor.arrayMap(v1 => mapAccumL(i => card => {
        if (i >= 0 && i < v1.length && v1[i].card.id === card.id) {
          return {
            accum: i + 1 | 0,
            value: (() => {
              const $0 = v1[i].draw;
              return {card, min: $0, max: $0};
            })()
          };
        }
        return {accum: i, value: {card, min: 0, max: 0}};
      })(0)(cards$p).value)(mkDrawPattern(sumBy1(v1 => v1.count)(cards$p) - v.count | 0)(cards$p));
    }
    if (v.mode === "Choice") {
      return Data$dFunctor.arrayMap(v1 => Data$dFunctor.arrayMap(card => ({card, min: 1, max: card.count}))(v1))(TcgCalculator$dMath.combinations(v.count)(cards$p));
    }
    if (v.mode === "LeftOne") {
      return Data$dFunctor.arrayMap(v1 => Data$dFunctor.arrayMap(card => ({card, min: 0, max: card.count - 1 | 0}))(v1))(TcgCalculator$dMath.combinations(v.count)(cards$p));
    }
    if (v.mode === "LeftAll") {
      return Data$dFunctor.arrayMap(v1 => Data$dFunctor.arrayMap(card => ({card, min: 0, max: 0}))(v1))(TcgCalculator$dMath.combinations(v.count)(cards$p));
    }
    $runtime.fail();
  })());
};
const mergeConditionPattern = m1 => m2 => Data$dMap$dInternal.unsafeUnionWith(
  Data$dUUID.ordUUID.compare,
  a => b => ({card: a.card, min: a.min + b.min | 0, max: min(a.max)(b.max)}),
  m1,
  m2
);
const isValidConditionPattern = /* #__PURE__ */ (() => {
  const go = v => {
    if (v.tag === "Leaf") { return true; }
    if (v.tag === "Node") { return go(v._5) && v._4.min <= v._4.max && v._4.min <= v._4.card.count && go(v._6); }
    $runtime.fail();
  };
  return go;
})();
const countMatchingPatterns = deck => patterns => {
  const candidates = Data$dArray.mapMaybe((() => {
    const $0 = deck.hand;
    return pattern => {
      const go = v => {
        if (v.tag === "Leaf") { return 0; }
        if (v.tag === "Node") { return (go(v._5) + v._4.min | 0) + go(v._6) | 0; }
        $runtime.fail();
      };
      const remaining = go(pattern);
      if (remaining <= $0) { return Data$dMaybe.$Maybe("Just", {remaining, entries: pattern}); }
      return Data$dMaybe.Nothing;
    };
  })())(patterns);
  if (candidates.length === 0) { return Data$dBigInt.semiringBigInt.zero; }
  return Data$dFoldable.foldrArray(card => k => hand => candidates$1 => sumBy3(draw => {
    const hand$p = hand - draw | 0;
    const candidates$p = Data$dArray.mapMaybe((() => {
      const $0 = card.id;
      return candidate => {
        const v = lookup($0)(candidate.entries);
        if (v.tag === "Nothing") {
          if (candidate.remaining <= hand$p) { return Data$dMaybe.$Maybe("Just", candidate); }
          return Data$dMaybe.Nothing;
        }
        if (v.tag === "Just") {
          const remaining = candidate.remaining - v._1.min | 0;
          if (v._1.min <= draw && draw <= v._1.max && remaining <= hand$p) { return Data$dMaybe.$Maybe("Just", {...candidate, remaining}); }
          return Data$dMaybe.Nothing;
        }
        $runtime.fail();
      };
    })())(candidates$1);
    if (candidates$p.length === 0) { return Data$dBigInt.semiringBigInt.zero; }
    return Data$dBigInt.biMul(TcgCalculator$dMath.combinationNumber(card.count)(draw))(k(hand$p)(candidates$p));
  })(Data$dArray.rangeImpl(0, min(card.count)(hand))))((() => {
    const $0 = deck.others;
    return hand => v => TcgCalculator$dMath.combinationNumber($0)(hand);
  })())(deck.cards)(deck.hand)(candidates);
};
const calculateTotal = v => TcgCalculator$dMath.combinationNumber(sumBy1(v1 => v1.count)(v.cards) + v.others | 0)(v.hand);
const buildConditionPattern = cards => group => Data$dArray$dNonEmpty$dInternal.foldl1Impl(
  left => right => Control$dBind.arrayBind(left)(l => Control$dBind.arrayBind(right)(r => {
    const merged = mergeConditionPattern(l)(r);
    if (
      (() => {
        const go = v => {
          if (v.tag === "Leaf") { return true; }
          if (v.tag === "Node") { return go(v._5) && v._4.min <= v._4.max && v._4.min <= v._4.card.count && go(v._6); }
          $runtime.fail();
        };
        return go(merged);
      })()
    ) {
      return [merged];
    }
    return [];
  })),
  Data$dFunctor.arrayMap(mkConditionPattern(cards))(group)
);
const calculate = deck => conditions => countMatchingPatterns(deck)(normalizeConditionPatterns(Control$dBind.arrayBind(conditions)(buildConditionPattern(deck.cards))));
export {
  and,
  buildConditionPattern,
  calculate,
  calculateTotal,
  countMatchingPatterns,
  foldMap,
  foldMap1,
  fromFoldable,
  isValidConditionPattern,
  lookup,
  mapAccumL,
  max,
  member,
  mergeConditionPattern,
  min,
  mkConditionPattern,
  mkDrawPattern,
  monoidSet,
  normalizeConditionPatterns,
  normalizeDeck,
  sumBy,
  sumBy1,
  sumBy3
};
